export default {
      id: "send-plane-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#send-plane",
      toString: function () {
        return this.url;
      }
    }